<template>
  <form-panel
    v-loading.fullscreen.lock="fullscreenLoading"
    title="¿A quién?"
    width="large"
    @closePanel="closeModal">
    <div class="main padding-20">
      <p>¿A quién se enviará la campaña?</p>
      <h3>Seleccione los contactos</h3>
      <el-transfer
        v-model="selectedCustomer"
        :data="dataCustomers"
        :titles="['Cliente','Lista de Clientes']"
        :button-texts="['Eliminar', 'Agregar']"
        class="transfer__margin"
        filterable/>
      <el-checkbox
        v-model="checked"
        @change="selectListEvent"><span>Agregar una lista de correos</span></el-checkbox>
      <h3>Lista de Correos</h3>
      <el-row>
        <el-col :span="12">
          <el-autocomplete
            v-model="nameListSelected"
            :fetch-suggestions="fetchList"
            :disabled="onSelectList"
            style="width: 100%"
            class="inline-input"
            placeholder="Seleccione una lista"/>
        </el-col>
      </el-row>
      <h3>Si tienes una lista ya diseñada, buscala aquí.</h3>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-button
            type="primary"
            style="width: 100%"
            @click="toggleCampaignCreateList">
            <i class="icon-list"/>&nbsp;Crear nueva lista de contactos.
          </el-button>
        </el-col>
        <el-col :span="12">
          <el-button
            type="primary"
            @click="sendList">Guardar</el-button>
        </el-col>
      </el-row>
    </div>
    <campaign-create-list
      v-if="showCampaignListPanel"
      @nameGroup="getNameGroup"/>
  </form-panel>
</template>

<script>
import FormPanel from '@/components/_shared/form-panel'
import CampaignCreateList from '@/modules/campaigns/campaign-create-list-modal'
export default {
  name: 'CampaignAssignPanel',
  components: {
    FormPanel,
    CampaignCreateList
  },
  props: {
    message: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      dataList: null,
      nameListSelected: null,
      onSelectList: true,
      selectedCustomer: [],
      checked: false,
      fullscreenLoading: false,
      dataCustomers: []
    }
  },
  computed: {
    showCampaignListPanel () {
      return this.$store.getters['app/showCampaignListPanel']
    }
  },
  mounted () {
    this.fullscreenLoading = true
    let result = []
    let _promises = []
    _promises.push(this.$store.dispatch('customerGroups/query', {limit: 1000000}))
    _promises.push(this.$store.dispatch('customers/query', {
      'filters[whereNot][email][eq]': '',
      limit: 1000000,
      sort: 'email ASC'}))
    Promise.all(_promises)
      .then((data) => {
        this.dataList = data[0].data.items
        for (let list of data[0].data.items) {
          result.push({
            label: list.name,
            value: list.name
          })
        }
        let _customer = data[1].data.items
        _customer.forEach((item) => {
          if (item.email) {
            this.dataCustomers.push({
              label: item.email,
              key: item.id
            })
          }
        })
      }).catch(e => {
        this.$notify.error({
          message: 'Por favor, vuelve a intentarlo.'
        })
      }).finally(() => {
        this.fullscreenLoading = false
      })
    if (Object.keys(this.message).length > 0) {
      if (this.message.customerGroupId !== undefined) {
        if (this.message.customerGroupId !== null) {
          this.$store.dispatch('customerGroups/query', {
            'filters[where][id][eq]': this.message.customerGroupId,
            limit: 1000000
          }).then(({data}) => {
            this.nameListSelected = data.items[0].name
            this.checked = true
            this.onSelectList = false
          })
        }
      }
      if (this.message.emails !== null) {
        let emails = this.message.emails
        for (let customers of this.dataCustomers) {
          Object.keys(emails).forEach(key => {
            const email = emails[key]
            if (customers.label === email) {
              this.selectedCustomer.push(customers.key)
            }
          })
        }
      }
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('app/toggleCampaignAssignPanel')
    },
    toggleCampaignCreateList () {
      this.$store.dispatch('app/toggleCampaignListPanel')
    },
    toggleCampaignAssignPanel () {
      this.$store.dispatch('app/toggleCampaignAssignPanel')
    },
    fetchList (queryString, cb) {
      let result = []
      this.$store.dispatch('customerGroups/query', {limit: 1000000}).then(({data}) => {
        this.dataList = data.items
        for (let list of data.items) {
          result.push({
            label: list.name,
            value: list.name
          })
        }
        cb(result)
      })
    },
    selectListEvent () {
      this.nameListSelected = null
      this.onSelectList = !this.onSelectList
    },
    createListEmail () {
      let list = []
      if (this.selectedCustomer.length !== 0) {
        for (let email of this.selectedCustomer) {
          for (let customer of this.dataCustomers) {
            if (email === customer.key) {
              list.push(customer.label)
            }
          }
        }
      } else {
        this.$message.error('Debe seleccionar un email o crear una lista para continuar')
      }
      return list
    },
    findListEmail () {
      if (this.dataList !== null) {
        for (let list of this.dataList) {
          if (this.nameListSelected === list.name) {
            return list.id
          }
        }
      }
    },
    sendList () {
      let listMail = null
      if (this.selectedCustomer.length !== 0) {
        if (this.createListEmail().length !== 0) {
          listMail = this.createListEmail()
        }
      } else if (this.findListEmail() !== null) {
        listMail = this.findListEmail()
      } else if (this.nameListSelected !== null) {
        listMail = this.findListEmail()
      } else {
        this.$message.error('Debe crear o seleccionar una lista')
      }

      if (listMail !== undefined) {
        this.$emit('sendListCustomers', listMail)
        this.$store.dispatch('app/toggleCampaignAssignPanel')
        this.$message.success('Los destinatarios se asignaron con éxito')
      } else {
        this.$message.error('Debe crear o seleccionar una lista')
      }
    },
    getNameGroup (_name) {
      let result = []
      this.$store.dispatch('customerGroups/query', {limit: 1000000}).then(({data}) => {
        this.dataList = data.items
        for (let list of data.items) {
          result.push({
            label: list.name,
            value: list.name
          })
        }
      })
      this.checked = true
      this.onSelectList = false
      this.nameListSelected = _name
    }
  }
}
</script>

<style scoped lang="scss">
.main{
  h3{
    @include font-lato(12px, bold);
    color: #3E3E3E;
  }
  p{
    @include font-lato(14px, regular);
    color: #B5AFAF;
  }
  .transfer__margin {
    margin: 30px 0px 30px 80px;
  }
  .el-button {
    background-color: $primary;
    color: #ffffff;
    width: 100%;
    box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/campaign-assign-panel.vue